

import i18n from '../i18n';
export const selectedlanguage = lang =>
{
  i18n.changeLanguage(lang);
return {
   type: 'LANG_SELECTED',
   payload: lang
};
};
